<script setup lang="ts">
import type { NodeViewProps } from '@tiptap/vue-3';
import type { GlobalFieldId } from '#layers/data-model/types/schema/ids';
import { NodeViewWrapper } from '@tiptap/vue-3';
import { computed } from 'vue';
import CollectionFieldPathBadge from '#layers/data-model/components/Collection/CollectionFieldPathBadge.vue';

const { node } = defineProps<NodeViewProps>();

const rawFieldId = computed(() => node.attrs.rawFieldId as string | null | undefined ?? null);

const fieldIds = computed(() => {
	const fieldId = node.attrs.fieldId as GlobalFieldId | GlobalFieldId[] | null;

	if (!fieldId) return [];
	return Array.isArray(fieldId) ? fieldId : [fieldId];
});
</script>

<template>
	<NodeViewWrapper as="span" class="h-6 shrink-0" data-drag-handle>
		<CollectionFieldPathBadge
			:selected
			:path="fieldIds"
			:unresolved="rawFieldId !== null"
			:variant="selected ? 'subtle' : 'soft'"
		/>
	</NodeViewWrapper>
</template>
